/**
 * Constants for Reset Password flow
 */

export const SCREENS = {
  FORGOT_PASSWORD: 'forgot-password',
  VERIFY_CODE: 'verify-code',
  CHANGE_PASSWORD: 'change-password',
};

export const RESEND_COUNTDOWN_SECONDS = 120;
export const OTP_LENGTH = 6;
export const MAX_VERIFICATION_ATTEMPTS = 3;

export const NAVIGATION_DELAY_MS = 400;
export const RESEND_SUCCESS_DISPLAY_MS = 3000;
